export default __webpack_public_path__ + "static/media/1920.59acd167.png";